/* Leagues Cup 2026: client-side EN/ES language toggle
   Mirrors the React storefront: instant swap, no reload, localStorage-backed.
   Usage in Liquid:
     <span data-i18n="nav.shopAll">Shop All</span>        -> textContent
     <input data-i18n-ph="email.placeholder">              -> placeholder
     <a data-i18n-aria="nav.bag">                          -> aria-label
   Keep icons/markup OUTSIDE the data-i18n element (wrap only the text). */
(function () {
  "use strict";

  var STORAGE_KEY = "lc-lang";

  /* ---------------- dictionary (EN / ES) ---------------- */
  var DICT = {
    "lang.label": { en: "Language", es: "Idioma" },

    // nav / header
    "nav.shopAll": { en: "Shop All", es: "Ver Todo" },
    "nav.about": { en: "About", es: "Acerca de" },
    "nav.bag": { en: "Bag", es: "Bolsa" },

    // categories
    "cat.Tees": { en: "Tees", es: "Playeras" },
    "cat.Long Sleeve": { en: "Long Sleeve", es: "Manga Larga" },
    "cat.Bags": { en: "Bags", es: "Bolsas" },
    "cat.Accessories": { en: "Accessories", es: "Accesorios" },

    // announcement bar
    "ann.text": {
      en: "Free shipping on all Leagues Cup 2026 orders. Handmade, limited drop.",
      es: "Envío gratis en todos los pedidos de Leagues Cup 2026. Hechos a mano, edición limitada.",
    },
    "ann.notify": { en: "Notify", es: "Avísame" },
    "ann.onList": { en: "You're on the list", es: "Estás en la lista" },
    "email.placeholder": { en: "you@email.com", es: "tu@correo.com" },

    // trust bar
    "trust.handmade.t": { en: "Handmade Capsule", es: "Cápsula Hecha a Mano" },
    "trust.handmade.s": { en: "Limited small-batch runs", es: "Ediciones limitadas en lotes pequeños" },
    "trust.ship.t": { en: "USA · CAN · MEX", es: "USA · CAN · MEX" },
    "trust.ship.s": { en: "Tri-nation shipping at launch", es: "Envío tri-nacional al lanzamiento" },
    "trust.secure.t": { en: "Secure Checkout", es: "Pago Seguro" },
    "trust.secure.s": { en: "Encrypted & protected", es: "Cifrado y protegido" },
    "trust.drop.t": { en: "Drop List Access", es: "Acceso a la Lista" },
    "trust.drop.s": { en: "First dibs before public", es: "Primero antes que el público" },

    // product page CRO
    "pdp.urgency": { en: "Limited handmade run. Selling fast.", es: "Edición limitada hecha a mano. Se agota rápido." },
    "pdp.socialproof": { en: "fans repping the 2026 capsule", es: "fans con la cápsula 2026" },
    "pdp.trust.handmade": { en: "Handmade in NYC", es: "Hecho a mano en NYC" },
    "pdp.trust.limited": { en: "Limited numbered run", es: "Edición numerada limitada" },
    "pdp.trust.secure": { en: "Secure checkout", es: "Pago seguro" },
    "pdp.trust.returns": { en: "Free returns within 30 days", es: "Devoluciones gratis en 30 días" },
    "pdp.sticky.notify": { en: "Add to Bag", es: "Agregar a la Bolsa" },

    // countdown
    "cd.days": { en: "Days", es: "Días" },
    "cd.hrs": { en: "Hrs", es: "Hrs" },
    "cd.min": { en: "Min", es: "Min" },
    "cd.sec": { en: "Sec", es: "Seg" },

    // hero
    "hero.badge": { en: "● The Official 2026 Capsule", es: "● La Cápsula Oficial 2026" },
    "hero.para": {
      en: "USA · Canada · Mexico. The 2026 Leagues Cup merch drop. Handmade, limited, and built for the ones who live for the group stage through the final whistle.",
      es: "USA · Canadá · México. El drop de merch de la Leagues Cup 2026. Hecho a mano, limitado y creado para quienes viven desde la fase de grupos hasta el silbatazo final.",
    },
    "hero.cta": { en: "Explore the Collection", es: "Explora la Colección" },
    "hero.countdown": { en: "Kickoff countdown", es: "Cuenta regresiva" },

    // featured
    "feat.eyebrow": { en: "● The Drop", es: "● El Lanzamiento" },
    "feat.title": { en: "Signature Pieces", es: "Piezas Insignia" },
    "feat.desc": {
      en: "Handmade, limited runs. The four that define the 2026 capsule. Shop yours while they last.",
      es: "Ediciones limitadas hechas a mano. Las cuatro que definen la cápsula 2026. Compra la tuya antes de que se agoten.",
    },
    "feat.viewAll": { en: "View all", es: "Ver todo" },
    "feat.mobileCta": { en: "Shop the Full Collection", es: "Compra la Colección Completa" },

    // matchup
    "match.eyebrow": { en: "● Matchday Spotlight", es: "● Enfoque del Partido" },
    "match.title": { en: "Rivalries, Reimagined", es: "Rivalidades, Reimaginadas" },
    "match.desc": {
      en: "Every fixture is a border crossing. MLS meets LIGA MX in a single bracket, and the shirts on your back carry the weight of it.",
      es: "Cada partido es un cruce de fronteras. La MLS se enfrenta a la LIGA MX en un solo cuadro, y las playeras que llevas cargan con todo su peso.",
    },

    // story
    "story.eyebrow": { en: "The Story", es: "La Historia" },
    "story.l1": { en: "One Tournament.", es: "Un Torneo." },
    "story.l2": { en: "Two Leagues.", es: "Dos Ligas." },
    "story.l3": { en: "A Whole Continent.", es: "Todo un Continente." },
    "story.desc": {
      en: "Leagues Cup brings every MLS and LIGA MX club into the same bracket for a summer of rivalries settled on the pitch. This capsule translates that energy into wearable graphics: aztec geometry, tri-nation color, and trophy iconography, printed in small handmade runs.",
      es: "La Leagues Cup reúne a cada club de la MLS y la LIGA MX en el mismo cuadro para un verano de rivalidades definidas en la cancha. Esta cápsula traduce esa energía en gráficos para vestir: geometría azteca, color tri-nacional e iconografía del trofeo, impresos en pequeñas ediciones hechas a mano.",
    },
    "story.countries": { en: "Countries", es: "Países" },
    "story.leagues": { en: "Leagues", es: "Ligas" },
    "story.champion": { en: "Champion", es: "Campeón" },
    "story.caption": { en: "Collective Tee: Back", es: "Playera Collective: Espalda" },

    // lookbook
    "look.eyebrow": { en: "● The Campaign", es: "● La Campaña" },
    "look.title": { en: "The Lookbook", es: "El Lookbook" },
    "look.side": { en: "2026 Capsule", es: "Cápsula 2026" },
    "look.desc": {
      en: "Shot across three nations: the players, the kits, and the op-art geometry that defines this year's identity. Every frame is a mood for the drop.",
      es: "Fotografiado en tres naciones: los jugadores, los kits y la geometría op-art que define la identidad de este año. Cada toma es un estado de ánimo para el drop.",
    },

    // waitlist CTA
    "wl.eyebrow": { en: "● Now available", es: "● Ya disponible" },
    "wl.title": { en: "The 2026 Capsule Is Live", es: "La Cápsula 2026 Ya Está Aquí" },
    "wl.desc": {
      en: "The 2026 capsule is available now in limited handmade runs. Shop the collection before your size and colorway sell out.",
      es: "La cápsula 2026 ya está disponible en ediciones limitadas hechas a mano. Compra la colección antes de que se agote tu talla y color.",
    },
    "wl.cta": { en: "Shop The Collection", es: "Explora la Colección" },

    // partners
    "part.eyebrow": { en: "● Official Partners", es: "● Socios Oficiales" },
    "part.title": { en: "Powered By The Best", es: "Impulsado Por Los Mejores" },
    "part.desc": {
      en: "Leagues Cup 2026 is brought to you in partnership with the brands fueling the game across three countries.",
      es: "La Leagues Cup 2026 se presenta en alianza con las marcas que impulsan el juego en tres países.",
    },

    // footer
    "foot.seoTitle": {
      en: "Official Leagues Cup 2026 Apparel and Merchandise",
      es: "Ropa y Mercancía Oficial de la Leagues Cup 2026",
    },
    "foot.seoBody": {
      en: "Gear up for the biggest summer in North American soccer with official Leagues Cup 2026 merch. Three countries. Two leagues. One champion. All 18 Major League Soccer clubs and all 18 LIGA MX clubs go head to head. Browse the full collection of club jerseys, authentic on-pitch kits, training tops, tees, hoodies, and headwear repping your favorite side. Looking for what the players wear? Check out the on-pitch collection, or grab a limited handmade capsule drop before it's gone. From matchday tifos to everyday streetwear, we've got everything for the fan who lives for the crest. We also carry hats, bags, scarves, and collectibles alongside exclusive designs celebrating the USA, Canada, and Mexico. This is where the rivalry lives. Shop the drop and wear your allegiance.",
      es: "Prepárate para el verano más grande del fútbol norteamericano con la mercancía oficial de la Leagues Cup 2026. Tres países. Dos ligas. Un campeón. Los 18 clubes de la Major League Soccer y los 18 de la LIGA MX se enfrentan. Explora la colección completa de jerseys de clubes, kits auténticos on-pitch, tops de entrenamiento, playeras, sudaderas y gorras con tu equipo favorito. ¿Buscas lo que usan los jugadores? Descubre la colección on-pitch, o consigue una cápsula limitada hecha a mano antes de que se agote. Desde tifos de día de partido hasta streetwear diario, tenemos todo para el fan que vive por el escudo. También tenemos gorras, bolsas, bufandas y coleccionables junto a diseños exclusivos que celebran a USA, Canadá y México. Aquí es donde vive la rivalidad. Compra el drop y viste tu lealtad.",
    },
    "foot.col.service": { en: "Customer Service", es: "Servicio al Cliente" },
    "foot.col.worryfree": { en: "Worry Free Shopping", es: "Compra Sin Preocupaciones" },
    "foot.col.info": { en: "Information", es: "Información" },
    "foot.link.contact": { en: "Contact Us", es: "Contáctanos" },
    "foot.link.help": { en: "Help", es: "Ayuda" },
    "foot.link.sizechart": { en: "Size Chart", es: "Guía de Tallas" },
    "foot.link.findorder": { en: "Find Your Order", es: "Encuentra tu Pedido" },
    "foot.link.shipping": { en: "Shipping & Returns", es: "Envíos y Devoluciones" },
    "foot.link.promoterms": { en: "Promo Terms & Exclusions", es: "Términos y Exclusiones de Promoción" },
    "foot.link.returns90": { en: "30-Day Returns", es: "Devoluciones en 30 Días" },
    "foot.link.trackorder": { en: "Track My Order", es: "Rastrear mi Pedido" },
    "foot.link.myaccount": { en: "My Account", es: "Mi Cuenta" },
    "foot.link.about": { en: "About Leagues Cup", es: "Sobre la Leagues Cup" },
    "foot.link.affiliate": { en: "Affiliate Program", es: "Programa de Afiliados" },
    "foot.link.giftcards": { en: "Gift Cards", es: "Tarjetas de Regalo" },
    "foot.link.faq": { en: "FAQ", es: "Preguntas Frecuentes" },
    "foot.signup": { en: "Stay updated on drops & news", es: "Mantente al día con drops y noticias" },
    "foot.success": { en: "You're in. Watch your inbox.", es: "¡Listo! Revisa tu correo." },
    "foot.join": { en: "Join", es: "Unirse" },
    "foot.follow": { en: "Follow Us", es: "Síguenos" },
    "foot.disclaimer": {
      en: "Official Leagues Cup 2026 merchandise. Leagues Cup, MLS, and LIGA MX names, logos, and marks are the property of their respective owners. © 2026 Leagues Cup 2026 Shop. All rights reserved. 3 COUNTRIES · 2 LEAGUES · 1 CHAMPION.",
      es: "Mercancía oficial de la Leagues Cup 2026. Los nombres, logos y marcas de Leagues Cup, MLS y LIGA MX son propiedad de sus respectivos dueños. © 2026 Leagues Cup 2026 Shop. Todos los derechos reservados. 3 PAÍSES · 2 LIGAS · 1 CAMPEÓN.",
    },

    // cart drawer
    "cart.title": { en: "Your Bag", es: "Tu Bolsa" },
    "cart.empty": { en: "Your bag is empty", es: "Tu bolsa está vacía" },
    "cart.emptySub": { en: "Shop the 2026 capsule while limited runs last.", es: "Compra la cápsula 2026 mientras duren las ediciones limitadas." },
    "cart.viewBag": { en: "View Bag", es: "Ver Bolsa" },
    "cart.shopDrop": { en: "Shop the Drop", es: "Comprar el Drop" },
    "cart.shop": { en: "Shop the Collection", es: "Comprar la Colección" },
    "cart.subtotal": { en: "Subtotal", es: "Subtotal" },
    "cart.size": { en: "Size", es: "Talla" },
    "cart.notSaleTag": { en: "In stock now.", es: "Disponible ahora." },
    "cart.notice": {
      en: "Limited handmade runs. Secure your pieces now before they sell out.",
      es: "Ediciones limitadas hechas a mano. Asegura tus piezas ahora antes de que se agoten.",
    },
    "cart.notify": { en: "Get notified. Join the drop list", es: "Recibe aviso. Únete a la lista" },
    "cart.keep": { en: "Keep browsing", es: "Seguir explorando" },
    "cart.checkout": { en: "Checkout", es: "Pagar" },
    "cart.orderSummary": { en: "Order Summary", es: "Resumen del Pedido" },
    "cart.shippingNote": { en: "Shipping & taxes calculated at checkout.", es: "Envío e impuestos calculados al pagar." },
    "cart.keepShopping": { en: "Keep Shopping", es: "Seguir Comprando" },

    /* 404 */
    "err.offside": { en: "Offside", es: "Fuera de Juego" },
    "err.body": { en: "This page took a wrong turn on the counter-attack. Let's get you back in the game.", es: "Esta página se perdió en el contraataque. Volvamos al juego." },
    "err.backShop": { en: "Back to Shop", es: "Volver a la Tienda" },

    /* Search */
    "srch.eyebrow": { en: "Search", es: "Buscar" },
    "srch.title": { en: "Find Your Kit", es: "Encuentra tu Kit" },
    "srch.placeholder": { en: "Search the drop…", es: "Busca en el drop…" },
    "srch.btn": { en: "Search", es: "Buscar" },
    "srch.noMatch": { en: "No matches", es: "Sin resultados" },
    "srch.noMatchSub": { en: "Try another term, or browse the full collection.", es: "Prueba otro término o explora toda la colección." },
    "srch.shopAll": { en: "Shop All", es: "Ver Todo" },

    /* Collections list */
    "coll.eyebrow": { en: "The 2026 Capsule", es: "La Cápsula 2026" },
    "coll.title": { en: "Collections", es: "Colecciones" },

    // waitlist modal
    "wlm.dropping": { en: "● 2026 capsule", es: "● Cápsula 2026" },
    "wlm.eyebrow": { en: "Now available", es: "Ya disponible" },
    "wlm.notifyShort": { en: "Notify", es: "Avisar" },
    "wlm.title": { en: "Join the drop list", es: "Únete a la lista del drop" },
    "wlm.desc": {
      en: "Drop your email for restock alerts, new-release drops and exclusive updates from the 2026 capsule.",
      es: "Déjanos tu correo para recibir alertas de reposición, nuevos lanzamientos y novedades exclusivas de la cápsula 2026.",
    },
    "wlm.emailLabel": { en: "Email", es: "Correo" },
    "wlm.submit": { en: "Sign me up", es: "Regístrame" },
    "wlm.successTitle": { en: "You're on the list", es: "Estás en la lista" },
    "wlm.done": { en: "Done", es: "Listo" },

    // shop / collection page
    "shop.eyebrow": { en: "The 2026 Capsule", es: "La Cápsula 2026" },
    "shop.title": { en: "Shop All", es: "Ver Todo" },
    "shop.all": { en: "All", es: "Todo" },
    "shop.sort": { en: "Sort", es: "Ordenar" },
    "shop.empty": { en: "Nothing here yet", es: "Nada aquí todavía" },
    "shop.emptySub": { en: "Check back soon. The drop is loading.", es: "Vuelve pronto. El drop está cargando." },
    "shop.sortFeatured": { en: "Featured", es: "Destacados" },
    "shop.sortPriceAsc": { en: "Price: Low to High", es: "Precio: Menor a Mayor" },
    "shop.sortPriceDesc": { en: "Price: High to Low", es: "Precio: Mayor a Menor" },
    "shop.sortAlpha": { en: "Alphabetical", es: "Alfabético" },

    // product card
    "pc.comingSoon": { en: "In Stock", es: "En Stock" },
    "pc.view": { en: "View Product", es: "Ver Producto" },

    // product page
    "pdp.home": { en: "Home", es: "Inicio" },
    "pdp.shop": { en: "Shop", es: "Tienda" },
    "pdp.comingSoon": { en: "In Stock", es: "En Stock" },
    "pdp.size": { en: "Size", es: "Talla" },
    "pdp.selectOne": { en: "select one", es: "elige una" },
    "pdp.sizeGuide": { en: "Size Guide", es: "Guía de Tallas" },
    "pdp.quantity": { en: "Quantity", es: "Cantidad" },
    "pdp.addToBag": { en: "Add to Bag", es: "Agregar a la Bolsa" },
    "pdp.addedToBag": { en: "Added to Bag", es: "Agregado a la Bolsa" },
    "pdp.notify": { en: "Add to Bag", es: "Agregar a la Bolsa" },
    "pdp.notSaleTag": { en: "In stock · Ships in 1–2 business days", es: "En stock · Envío en 1–2 días hábiles" },
    "pdp.fitGuide": { en: "Fit Guide", es: "Guía de Ajuste" },
    "pdp.sizeGuideDesc": { en: "Measurements in inches, laid flat. Boxy modern fit. Size down for a slimmer look.", es: "Medidas en pulgadas, en plano. Corte moderno holgado. Elige una talla menos para un look más ajustado." },
    "pdp.chest": { en: "Chest (in)", es: "Pecho (in)" },
    "pdp.length": { en: "Length (in)", es: "Largo (in)" },
    "pdp.trust.secure": { en: "Secure checkout", es: "Pago seguro" },
    "pdp.trust.ship": { en: "USA · CAN · MEX", es: "USA · CAN · MEX" },
    "pdp.trust.handmade": { en: "Handmade run", es: "Edición hecha a mano" },
    "pdp.details": { en: "Details", es: "Detalles" },
    "pdp.related": { en: "Complete the Fit", es: "Completa el Look" },
  };

  /* ---------------- runtime ---------------- */
  function detectInitial() {
    try {
      var stored = window.localStorage.getItem(STORAGE_KEY);
      if (stored === "en" || stored === "es") return stored;
    } catch (e) {}
    var nav = (window.navigator.language || "").toLowerCase();
    return nav.indexOf("es") === 0 ? "es" : "en";
  }

  var lang = detectInitial();

  function t(key) {
    var entry = DICT[key];
    return entry ? entry[lang] : null;
  }

  // ES translation for a key, or null when absent
  function es(key) {
    var entry = DICT[key];
    return entry ? entry.es : null;
  }

  /* Non-destructive: the English/original value is whatever Liquid rendered
     (captured once). We only override to Spanish; switching back to EN
     restores the captured original, so merchant edits are never clobbered. */
  function applyText(el) {
    var key = el.getAttribute("data-i18n");
    if (el.getAttribute("data-i18n-orig") === null) {
      el.setAttribute("data-i18n-orig", el.textContent);
    }
    var orig = el.getAttribute("data-i18n-orig");
    var tr = es(key);
    el.textContent = lang === "es" && tr !== null ? tr : orig;
  }

  function applyAttr(el, attrName, keyAttr, origAttr) {
    var key = el.getAttribute(keyAttr);
    if (el.getAttribute(origAttr) === null) {
      el.setAttribute(origAttr, el.getAttribute(attrName) || "");
    }
    var orig = el.getAttribute(origAttr);
    var tr = es(key);
    el.setAttribute(attrName, lang === "es" && tr !== null ? tr : orig);
  }

  function apply(root) {
    root = root || document;
    var els = root.querySelectorAll("[data-i18n]");
    for (var i = 0; i < els.length; i++) applyText(els[i]);
    var ph = root.querySelectorAll("[data-i18n-ph]");
    for (var j = 0; j < ph.length; j++) applyAttr(ph[j], "placeholder", "data-i18n-ph", "data-i18n-ph-orig");
    var ar = root.querySelectorAll("[data-i18n-aria]");
    for (var k = 0; k < ar.length; k++) applyAttr(ar[k], "aria-label", "data-i18n-aria", "data-i18n-aria-orig");
  }

  function syncButtons() {
    var btns = document.querySelectorAll("[data-lang-btn]");
    for (var i = 0; i < btns.length; i++) {
      var isActive = btns[i].getAttribute("data-lang-btn") === lang;
      btns[i].setAttribute("aria-pressed", isActive ? "true" : "false");
      btns[i].classList.toggle("lc-lang-active", isActive);
    }
  }

  function setLang(l) {
    if (l !== "en" && l !== "es") return;
    lang = l;
    try { window.localStorage.setItem(STORAGE_KEY, l); } catch (e) {}
    document.documentElement.lang = l;
    apply(document);
    syncButtons();
  }

  function init() {
    document.documentElement.lang = lang;
    apply(document);
    syncButtons();
    var btns = document.querySelectorAll("[data-lang-btn]");
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener("click", function () {
        setLang(this.getAttribute("data-lang-btn"));
      });
    }
  }

  // expose for other scripts (cart drawer re-renders, etc.)
  window.LC_I18N = { t: t, apply: apply, setLang: setLang, get lang() { return lang; } };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
